import { Link, useLocation } from "react-router-dom";
import { MapPin, Calendar } from "lucide-react";

export default function StickyMobileCTA() {
    const location = useLocation();
    if (location.pathname.startsWith("/admin")) return null;
    return (
        <div data-testid="sticky-mobile-cta" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-ink/95 backdrop-blur-md border-t border-champagne/40 grid grid-cols-2">
            <Link to="/clinics" data-testid="sticky-find" className="flex items-center justify-center gap-2 py-4 text-bone text-[0.65rem] uppercase tracking-[0.2em] border-r border-champagne/30">
                <MapPin size={14} strokeWidth={1.2} /> Find Clinic
            </Link>
            <Link to="/contact" data-testid="sticky-book" className="flex items-center justify-center gap-2 py-4 bg-champagne text-ink text-[0.65rem] uppercase tracking-[0.2em]">
                <Calendar size={14} strokeWidth={1.2} /> Book Consult
            </Link>
        </div>
    );
}
